import { useFirebaseTableStore } from '../../../../store/shared/firebase-table-store';
import { collection, orderBy, where } from 'firebase/firestore';
import { db } from '@/firebase';
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { Registration } from '../../entities/registration';

const filtersBuilderFunction = (filters) => {
	const queryData = [];

	if (filters.fullName) {
		queryData.push(where('fullName', '>=', filters.fullName));
		queryData.push(where('fullName', '<=', filters.fullName + '\uf8ff'));
	} else {
		queryData.push(where('fullName', '<=', '\uf8ff'));
	}
	if (filters.phoneNumber) {
		queryData.push(where('phoneNumber', '>=', filters.phoneNumber));
		queryData.push(where('phoneNumber', '<=', filters.phoneNumber + '\uf8ff'));
	} else {
		queryData.push(where('phoneNumber', '<=', '\uf8ff'));
	}
	if (filters.identityNumber) {
		queryData.push(where('identityNumber', '>=', filters.identityNumber));
		queryData.push(where('identityNumber', '<=', filters.identityNumber + '\uf8ff'));
	} else {
		queryData.push(where('identityNumber', '<=', '\uf8ff'));
	}

	queryData.push(orderBy('createdAt', 'desc'));

	if (filters.gender) {
		queryData.push(where('gender', '>=', filters.gender));
		queryData.push(where('gender', '<=', filters.gender + '\uf8ff'));
	} else {
		queryData.push(where('gender', '<=', '\uf8ff'));
	}

	if (typeof filters.needTransportation === 'boolean') {
		queryData.push(where('needTransportation', '>=', filters.needTransportation));
		queryData.push(where('needTransportation', '<=', filters.needTransportation));
	} else {
		queryData.push(where('needTransportation', '<=', true));
	}

	if (filters.createdAt?.from) {
		const date = new Date(filters.createdAt?.from);
		date.setHours(0, 0, 0, 0);
		queryData.push(where('createdAt', '>=', date));
	} else {
		queryData.push(where('createdAt', '>=', new Date(0)));
	}

	if (filters.createdAt?.to) {
		const date = new Date(filters.createdAt?.to);
      date.setHours(23, 59, 59, 999);
		queryData.push(where('createdAt', '<=', date));
	} else {
		queryData.push(where('createdAt', '<=', new Date()));
	}

	if (filters.status) {
		queryData.push(where('status', '>=', filters.status));
		queryData.push(where('status', '<=', filters.status));
	} else {
		queryData.push(where('status', '<=', '\uf8ff'));
	}

	if (filters.diplomaName) {
		queryData.push(where('diploma.name', '>=', filters.diplomaName));
		queryData.push(where('diploma.name', '<=', filters.diplomaName + '\uf8ff'));
	} else {
		queryData.push(where('diploma.name', '<=', '\uf8ff'));
	}

	if (filters.city) {
		queryData.push(where('city', '>=', filters.city));
		queryData.push(where('city', '<=', filters.city + '\uf8ff'));
	} else {
		queryData.push(where('city', '<=', '\uf8ff'));
	}

	if (filters.favoriteTimeOfDay) {
		queryData.push(where('favoriteTimeOfDay', '>=', filters.favoriteTimeOfDay));
		queryData.push(where('favoriteTimeOfDay', '<=', filters.favoriteTimeOfDay + '\uf8ff'));
	} else {
		queryData.push(where('favoriteTimeOfDay', '<=', '\uf8ff'));
	}

	return queryData;
};

export const getRegistrationTableStore = () => {
	const authStore = useAuthStore();

	const dataCollection = collection(
		db,
		`tenants/${authStore.tenantId}/education/default/registrations`,
	);
	const tableStore = useFirebaseTableStore({
		tableName: 'registrationResponses',
		collection: dataCollection,
		filtersBuilderFunction,
		documentMappingFunction: (doc) => {
			return new Registration({ ...doc.data(), id: doc.id });
		},
		// realtime: true,
	});

	return tableStore;
};
